/**
 * Image URL strategy for Fleasing frontend.
 *
 * Sizes:
 *   - 'thumbnail' : small image for cards, grids, listing overviews (~400px wide)
 *   - 'medium'    : medium image for larger previews (~800px wide)
 *   - 'original'  : full-size image for detail pages and galleries
 *
 * The backend does not yet serve size variants, so all sizes currently return
 * the original URL. When the backend adds thumbnail endpoints (e.g. ?size=thumb),
 * update the mapping below in one place.
 */

const SIZE_SUFFIX = {
    thumbnail: null,  // e.g. '?size=thumbnail' when backend supports it
    medium: null,     // e.g. '?size=medium'
    original: null,
};

/**
 * Returns the URL for a listing image at the requested size.
 *
 * @param {string|null|undefined} url  - The original image URL (e.g. img.path)
 * @param {'thumbnail'|'medium'|'original'} size - Desired size variant
 * @param {string} fallback - URL to use when no image is available
 * @returns {string}
 */
export function getListingImageUrl(url, size = 'thumbnail', fallback = '') {
    if (!url) return fallback;
    const suffix = SIZE_SUFFIX[size];
    if (!suffix) return url;
    return `${url}${suffix}`;
}
